(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sheetrock", [], factory);
	else if(typeof exports === 'object')
		exports["sheetrock"] = factory();
	else
		root["sheetrock"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*!
	                                                                                                                                                                                                                                                                   * Sheetrock
	                                                                                                                                                                                                                                                                   * Quickly connect to, query, and lazy-load data from Google Sheets.
	                                                                                                                                                                                                                                                                   * https://chriszarate.github.io/sheetrock/
	                                                                                                                                                                                                                                                                   * License: MIT
	                                                                                                                                                                                                                                                                   */
	
	/* global window */
	
	var _options = __webpack_require__(1);
	
	var _options2 = _interopRequireDefault(_options);
	
	var _request = __webpack_require__(5);
	
	var _request2 = _interopRequireDefault(_request);
	
	var _response = __webpack_require__(6);
	
	var _response2 = _interopRequireDefault(_response);
	
	var _config = __webpack_require__(2);
	
	var _transport = __webpack_require__(8);
	
	var _transport2 = _interopRequireDefault(_transport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Shimmed with 'transport-browser' in browser.
	
	var version = '1.1.0';
	
	function sheetrock() {
	  var userOptions = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var data = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	  var options = null;
	  var request = null;
	  var response = null;
	
	  // Call the user's callback function or rethrow error.
	  function handleError(error) {
	    if (error && error.name === 'SheetrockError') {
	      if (request && request.update) {
	        request.update({ failed: true });
	      }
	    }
	
	    if (userOptions.callback) {
	      userOptions.callback(error, options, response);
	      return;
	    }
	
	    if (error) {
	      throw error;
	    }
	  }
	
	  try {
	    options = new _options2.default(_extends({ target: this }, userOptions), !!data);
	    request = new _request2.default(options);
	    response = new _response2.default(request);
	  } catch (error) {
	    handleError(error);
	  }
	
	  if (data) {
	    response.loadData(data, handleError);
	  } else if (options && request && response) {
	    (0, _transport2.default)(response, handleError);
	  }
	
	  return this;
	}
	
	_extends(sheetrock, { defaults: _config.defaults, version: version });
	
	// If jQuery is available as a global, register as a plugin.
	try {
	  window.jQuery.fn.sheetrock = sheetrock;
	} catch (ignore) {/* empty */}
	
	exports.default = sheetrock;
	module.exports = exports['default'];

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _config = __webpack_require__(2);
	
	var config = _interopRequireWildcard(_config);
	
	var _util = __webpack_require__(3);
	
	var _error = __webpack_require__(4);
	
	var _error2 = _interopRequireDefault(_error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Support some legacy option names.
	function translateLegacyOptions(options) {
	  var newOptions = {};
	
	  Object.keys(options).forEach(function (key) {
	    if ({}.hasOwnProperty.call(config.legacyOptions, key)) {
	      newOptions[config.legacyOptions[key]] = options[key];
	    } else {
	      newOptions[key] = options[key];
	    }
	  });
	
	  return newOptions;
	}
	
	function setUserOptions(options) {
	  var validatedOptions = {};
	
	  // Look for valid DOM element target.
	  validatedOptions.target = (0, _util.extractElement)(options.target);
	
	  // Correct bad integer values.
	  validatedOptions.fetchSize = Math.max(0, parseInt(options.fetchSize, 10) || 0);
	
	  // Require DOM element or a callback function. Otherwise, the data has nowhere to go.
	  if (!validatedOptions.target && !options.callback) {
	    throw new _error2.default('No element targeted or callback provided.');
	  }
	
	  // Extend default options.
	  return _extends({}, config.defaults, options, validatedOptions);
	}
	
	function setRequestOptions(options, data) {
	  // If the user passed data, we don't want to validate the URL.
	  if (data) {
	    return { data: data };
	  }
	
	  // Get API endpoint, key, and gid from a Google Sheet URL.
	  var sheetType = null;
	  Object.keys(config.sheetTypes).forEach(function (key) {
	    var value = config.sheetTypes[key];
	    if (value.keyFormat.test(options.url) && value.gidFormat.test(options.url)) {
	      sheetType = value;
	    }
	  });
	
	  if (sheetType) {
	    var sheetKey = options.url.match(sheetType.keyFormat)[1];
	    return {
	      key: sheetKey,
	      gid: options.url.match(sheetType.gidFormat)[1],
	      apiEndpoint: sheetType.apiEndpoint.replace('%key%', sheetKey)
	    };
	  }
	
	  // Require a Sheet key and gid.
	  throw new _error2.default('No key/gid in the provided URL.');
	}
	
	var Options = function Options() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var data = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	  _classCallCheck(this, Options);
	
	  this.user = setUserOptions(translateLegacyOptions(options));
	  this.request = setRequestOptions(this.user, data);
	
	  // Generate a request ID that can be used as a caching key.
	  this.requestIndex = this.request.key + '_' + this.request.gid + '_' + this.user.query;
	};
	
	exports.default = Options;
	module.exports = exports['default'];

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Defaults for Sheetrock user options.
	var defaults = {
	  url: '', // String  -- Google Sheet URL
	  query: '', // String  -- Google Visualization API query
	  target: null, // DOM Element -- An element to append output to
	  fetchSize: 0, // Integer -- Number of rows to fetch (0 = all)
	  labels: [], // Array   -- Override *returned* column labels
	  rowTemplate: null, // Function / Template
	  callback: null, // Function
	  reset: false };
	
	// Map of legacy (pre-v1.0.0) option names to current user option names.
	var legacyOptions = {
	  sql: 'query',
	  resetStatus: 'reset',
	  chunkSize: 'fetchSize',
	  rowHandler: 'rowTemplate'
	};
	
	// Google Visualization API endpoints and parameter formats.
	var sheetTypes = {
	  2014: {
	    apiEndpoint: 'https://docs.google.com/spreadsheets/d/%key%/gviz/tq?',
	    keyFormat: new RegExp('spreadsheets/d/([^/#]+)', 'i'),
	    gidFormat: new RegExp('gid=([^/&#]+)', 'i')
	  },
	  2010: {
	    apiEndpoint: 'https://spreadsheets.google.com/tq?key=%key%&',
	    keyFormat: new RegExp('key=([^&#]+)', 'i'),
	    gidFormat: new RegExp('gid=([^/&#]+)', 'i')
	  }
	};
	
	exports.defaults = defaults;
	exports.legacyOptions = legacyOptions;
	exports.sheetTypes = sheetTypes;

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	// Extract the string contained in a cell object.
	function getCellValue(cell) {
	  var value = cell ? cell.f || cell.v || cell : '';
	
	  // Extract cell value while avoiding array values.
	  if (value instanceof Array) {
	    value = value.join('');
	  }
	
	  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	    return '';
	  }
	
	  return ('' + value).replace(/^\s+|\s+$/, '');
	}
	
	// Extract a DOM element from a possible jQuery blob.
	function extractElement(blob) {
	  var el = blob;
	
	  if ((typeof el === 'undefined' ? 'undefined' : _typeof(el)) === 'object' && el.jquery && el.length) {
	    el = el[0];
	  }
	
	  return el && el.nodeType && el.nodeType === 1 ? el : null;
	}
	
	// Append HTML output to DOM.
	function append(target, html) {
	  if (target && target.insertAdjacentHTML) {
	    target.insertAdjacentHTML('beforeEnd', html);
	  }
	}
	
	// Return true if the DOM element has the specified class.
	function hasClass(el, className) {
	  var classes = ' ' + el.className + ' ';
	  return classes.indexOf(' ' + className + ' ') !== -1;
	}
	
	// Return true if the DOM element is a table.
	function isTable(el) {
	  return el && el.tagName === 'TABLE';
	}
	
	// Wrap a string in tag.
	function wrapTag(str, tag) {
	  return '<' + tag + '>' + str + '</' + tag + '>';
	}
	
	// Default row template: Output a row object as an HTML table row. Use "td"
	// for table body row, "th" for table header rows.
	function toHTML(row) {
	  var tag = row.num ? 'td' : 'th';
	  var html = '';
	  Object.keys(row.cells).forEach(function (key) {
	    html += wrapTag(row.cells[key], tag);
	  });
	  return wrapTag(html, 'tr');
	}
	
	exports.append = append;
	exports.extractElement = extractElement;
	exports.getCellValue = getCellValue;
	exports.hasClass = hasClass;
	exports.isTable = isTable;
	exports.toHTML = toHTML;
	exports.wrapTag = wrapTag;

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SheetrockError = function (_Error) {
	  _inherits(SheetrockError, _Error);
	
	  function SheetrockError() {
	    var message = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
	    var code = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	    _classCallCheck(this, SheetrockError);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(SheetrockError).call(this));
	
	    _this.name = 'SheetrockError';
	    _this.code = code;
	    _this.message = message;
	    return _this;
	  }
	
	  return SheetrockError;
	}(Error);
	
	exports.default = SheetrockError;
	module.exports = exports['default'];

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _error = __webpack_require__(4);
	
	var _error2 = _interopRequireDefault(_error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Provide a simple state store shared across requests.
	var stateCache = {
	  defaults: {
	    failed: false,
	    header: 0,
	    labels: null,
	    loaded: false,
	    offset: 0
	  },
	  store: {}
	};
	
	var Request = function () {
	  function Request(options) {
	    _classCallCheck(this, Request);
	
	    this.options = options;
	    this.index = options.requestIndex;
	
	    // Abandon requests that have previously generated an error.
	    if (this.state.failed) {
	      throw new _error2.default('A previous request for this resource failed.');
	    }
	
	    // Abandon requests that have already been loaded.
	    if (this.state.loaded) {
	      throw new _error2.default('No more rows to load!');
	    }
	  }
	
	  _createClass(Request, [{
	    key: 'update',
	
	
	    // Extend exsiting attributes with passed attributes.
	    value: function update() {
	      var attributes = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	      stateCache.store[this.index] = _extends(this.state, attributes);
	    }
	  }, {
	    key: 'state',
	    get: function get() {
	      var reset = this.options.user.reset || this.options.request.data;
	      if (!{}.hasOwnProperty.call(stateCache.store, this.index) || reset) {
	        stateCache.store[this.index] = _extends({}, stateCache.defaults);
	      }
	      return stateCache.store[this.index];
	    }
	
	    // Assemble a full URI for the query.
	
	  }, {
	    key: 'url',
	    get: function get() {
	      // If requested, make a request for paged data.
	      var size = this.options.user.fetchSize;
	      var pageQuery = size ? ' limit ' + (size + 1) + ' offset ' + this.state.offset : '';
	
	      var queryVars = ['gid=' + encodeURIComponent(this.options.request.gid), 'tq=' + encodeURIComponent(this.options.user.query + pageQuery)];
	      return this.options.request.apiEndpoint + queryVars.join('&');
	    }
	  }]);
	
	  return Request;
	}();
	
	exports.default = Request;
	module.exports = exports['default'];

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _row = __webpack_require__(7);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _error = __webpack_require__(4);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _util = __webpack_require__(3);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Get useful information about the response.
	var Response = function () {
	  function Response(request) {
	    _classCallCheck(this, Response);
	
	    this.request = request;
	    this.options = request.options;
	  }
	
	  _createClass(Response, [{
	    key: 'setAttributes',
	    value: function setAttributes() {
	      var fetchSize = this.options.user.fetchSize;
	      var rows = this.raw.table.rows;
	      var cols = this.raw.table.cols;
	
	      // Initialize a hash for the response attributes.
	      var attributes = {
	        last: rows.length - 1,
	        rowNumberOffset: this.request.state.header || 0
	      };
	
	      // Determine if Google has extracted column labels from a header row.
	      var columnLabels = this.request.state.labels;
	      if (!this.request.state.offset) {
	        // Use extracted column labels, the first row, or column letter.
	        columnLabels = cols.map(function (col, i) {
	          if (col.label) {
	            return col.label.replace(/\s/g, '');
	          }
	
	          // Get column labels from the first row of the response.
	          attributes.last += 1;
	          attributes.rowNumberOffset = 1;
	          return util.getCellValue(rows[0].c[i]) || col.id;
	        });
	
	        this.request.update({
	          header: attributes.rowNumberOffset,
	          labels: columnLabels,
	          offset: this.request.state.offset + attributes.rowNumberOffset
	        });
	      }
	
	      // The Google API generates an unrecoverable error when the 'offset' is
	      // larger than the number of available rows, which is problematic for
	      // paged requests. As a workaround, we request one more row than we need
	      // and stop when we see less rows than we requested.
	
	      // Remember whether this request has been fully loaded.
	      if (!fetchSize || rows.length - attributes.rowNumberOffset < fetchSize) {
	        attributes.last += 1;
	        this.request.update({ loaded: true });
	      }
	
	      // If column labels are provided and have the expected length, use them.
	      var userLabels = this.options.user.labels;
	      var userLabelsValid = userLabels && userLabels.length === columnLabels.length;
	      attributes.labels = userLabelsValid ? userLabels : columnLabels;
	
	      // Return the response attributes.
	      this.attributes = attributes;
	    }
	
	    // Parse data, row by row, and generate a simpler output array.
	
	  }, {
	    key: 'setOutput',
	    value: function setOutput() {
	      var _this = this;
	
	      this.rows = [];
	
	      // Add a header row constructed from the column labels, if appropriate.
	      if (!this.request.state.offset && !this.attributes.rowNumberOffset) {
	        this.rows.push(new _row2.default(0, this.attributes.labels, this.attributes.labels));
	      }
	
	      // Each table cell ('c') can contain two properties: 'p' contains
	      // formatting and 'v' contains the actual cell value.
	
	      // Loop through each table row.
	      this.raw.table.rows.forEach(function (row, i) {
	        // Proceed if the row has cells and the row index is within the targeted
	        // range. (This avoids displaying too many rows when paging data.)
	        if (row.c && i < _this.attributes.last) {
	          // Get the "real" row index (not counting header rows). Create a row
	          // object and add it to the output array.
	          var counter = _this.request.state.offset + i + 1 - _this.attributes.rowNumberOffset;
	          _this.rows.push(new _row2.default(counter, row.c, _this.attributes.labels));
	        }
	      });
	
	      // Remember the new row offset.
	      this.request.update({
	        offset: this.request.state.offset + this.options.user.fetchSize
	      });
	    }
	
	    // Generate HTML from rows using a template.
	
	  }, {
	    key: 'setHTML',
	    value: function setHTML() {
	      var target = this.options.user.target;
	      var template = this.options.user.rowTemplate || util.toHTML;
	      var isTable = util.isTable(target);
	      var needsHeader = target && util.hasClass(target, 'sheetrock-header');
	
	      // Pass each row to the row template. Only parse header rows if the target
	      // is a table or indicates via className that it wants the header.
	      var headerHTML = '';
	      var bodyHTML = '';
	      this.rows.forEach(function (row) {
	        if (row.num) {
	          bodyHTML += template(row);
	        } else if (isTable || needsHeader) {
	          headerHTML += template(row);
	        }
	      });
	
	      if (isTable) {
	        headerHTML = util.wrapTag(headerHTML, 'thead');
	        bodyHTML = util.wrapTag(bodyHTML, 'tbody');
	      }
	
	      util.append(target, headerHTML + bodyHTML);
	
	      this.html = headerHTML + bodyHTML;
	    }
	
	    // Load API response.
	
	  }, {
	    key: 'loadData',
	    value: function loadData(rawData, callback) {
	      var thrown = null;
	
	      try {
	        this.raw = rawData;
	        this.setAttributes();
	        this.setOutput();
	        this.setHTML();
	      } catch (error) {
	        thrown = new _error2.default('Unexpected API response format.');
	      }
	
	      callback(thrown);
	    }
	  }]);
	
	  return Response;
	}();
	
	exports.default = Response;
	module.exports = exports['default'];

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __webpack_require__(3);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Row = function () {
	  function Row(number, cellsArray, labels) {
	    _classCallCheck(this, Row);
	
	    this.num = number;
	    this.cellsArray = cellsArray.map(_util.getCellValue);
	    this.labels = labels;
	  }
	
	  // Get an object with labels as keys.
	
	
	  _createClass(Row, [{
	    key: 'cells',
	    get: function get() {
	      var _this = this;
	
	      var cellsObj = {};
	      this.labels.forEach(function (label, index) {
	        cellsObj[label] = _this.cellsArray[index];
	      });
	      return cellsObj;
	    }
	  }]);
	
	  return Row;
	}();
	
	exports.default = Row;
	module.exports = exports['default'];

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _error = __webpack_require__(4);
	
	var _error2 = _interopRequireDefault(_error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global window */
	
	var headElement = window.document.getElementsByTagName('head')[0];
	var callbackIndex = 0;
	
	function get(response, callback) {
	  var scriptElement = window.document.createElement('script');
	  var callbackName = '_sheetrock_callback_' + callbackIndex;
	  callbackIndex += 1;
	
	  function always() {
	    headElement.removeChild(scriptElement);
	    delete window[callbackName];
	  }
	
	  function success(data) {
	    always();
	    response.loadData(data, callback);
	  }
	
	  function error() {
	    always();
	    callback(new _error2.default('Request failed.'));
	  }
	
	  window[callbackName] = success;
	
	  if (scriptElement.addEventListener) {
	    scriptElement.addEventListener('error', error, false);
	    scriptElement.addEventListener('abort', error, false);
	  }
	
	  scriptElement.type = 'text/javascript';
	  scriptElement.src = response.request.url + '&tqx=responseHandler:' + callbackName;
	  headElement.appendChild(scriptElement);
	}
	
	exports.default = get;
	module.exports = exports['default'];

/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** dist/sheetrock.min.js
 **/